import { inject, Injectable } from '@angular/core';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseConfigService {
    private readonly defaultConfig = inject(FUSE_CONFIG);
    private readonly configSubject = new BehaviorSubject(this.defaultConfig);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    public set config(value: any) {
        // Merge the new config over to the current config
        const config = merge({}, this.configSubject.getValue(), value);

        // Execute the observable
        this.configSubject.next(config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    public get config$(): Observable<any> {
        return this.configSubject.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    public reset(): void {
        // Set the config
        this.configSubject.next(merge({}, this.defaultConfig));
    }
}
